/**
 * AUTO-GENERATED by scripts/build-resume.mjs from resume.json.
 * Do not edit by hand -- changes will be overwritten on next build.
 * Edit resume.json and run `pnpm resume:build`.
 */

/**
 * Stack groups rendered on the Resume page Skills section. Order here is the
 * order they render in.
 */
export const skillGroups: { label: string; items: string[] }[] = [
  {
    label: 'ML & Optimization',
    items: ['MIP', 'LP', 'Multi-Objective Optimization', 'Multi-Commodity Network Flow', 'Bin-Packing', 'Network Design', 'Sensitivity Analysis', 'Scenario Analysis', 'Gurobi', 'OR-Tools', 'PuLP', 'Deep Learning', 'TensorFlow', 'CatBoost', 'Time-Series', 'NLP', 'SHAP', 'MLOps'],
  },
  {
    label: 'Programming',
    items: ['Python', 'Pandas', 'NumPy', 'PySpark', 'scikit-learn', 'SQL', 'TypeScript', 'React'],
  },
  {
    label: 'Platforms & Infra',
    items: ['Databricks', 'AWS SageMaker', 'AWS ECR', 'Snowflake', 'PostgreSQL', 'Palantir Foundry', 'Docker', 'Jenkins', 'CI/CD', 'Airflow', 'FastAPI', 'Vite', 'Streamlit', 'Plotly'],
  },
]
